import { ReactNode } from "react";
import {BoxProps} from "@chakra-ui/layout/dist/types/box";

import { Box, Divider, HStack, VStack } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";

import { IAppointmentDetails } from "../../../application/types/IAppointmentDetails";
import { AppointmentStartDate } from "./AppointmentStartDate";
import { AppointmentStatusTag } from "../../AppointmentStatusTag";

interface IProps extends BoxProps {
  appointment: IAppointmentDetails;
  actionButtons: ReactNode;
}

const AppointmentMobileRow = ({
  appointment,
  actionButtons,
  ...restProps
}: IProps) => {
  return (
    <Box my={2} {...restProps}>
      <HStack justify="space-between">
        <VStack align="flex-start" spacing={0}>
          <HStack>
            <AppointmentStartDate
              appointmentStartDate={appointment.startDate}
            />
            <AppointmentStatusTag status={appointment.status} />
          </HStack>
          <ChakraText fontSize="xl">{appointment.orgUnitFullName}</ChakraText>
          <HStack divider={<ChakraText mr={2}>{","}</ChakraText>}>
            <ChakraText>{appointment.queueName}</ChakraText>
            <ChakraText>{appointment.groupName}</ChakraText>
          </HStack>
        </VStack>
        {actionButtons}
      </HStack>

      <Divider mt={2} />
    </Box>
  );
};

export { AppointmentMobileRow };
